
if (!customElements.get('slide-show')) {
  class Slideshow extends HTMLElement {
    constructor() {
      super();
      this.swiperPrev = null;
      this.swiperNext = null;
      this.swiperPagination = null;
      this.swiperContainer = null;
      this.swiperScrollbar = null;
      this.slideshowSwiper = null;
    }

    connectedCallback() {
      this.swiperPrev = this.querySelector('.swiper-button-prev');
      this.swiperNext = this.querySelector('.swiper-button-next');
      this.swiperPagination = this.querySelector('.swiper-pagination');
      this.swiperContainer = this.querySelector('.swiper-container');
      this.swiperScrollbar = this.querySelector('.swiper-scrollbar');
      this.slideItems = this.querySelectorAll('.swiper-slide');

      if (this.swiperContainer) {
        this.initSwiper();
      }
      if (this.slideItems.length > 1) {
        this.slideClickHandler();
      }
    }

    initSwiper() {
      const autoplay = this.getAttribute('data-autoplay') === 'true';
      const loop = this.getAttribute('data-loop') === 'true' ? true : false;
      const autoplayDelay = Number(this.getAttribute('data-autoplay-delay')) || 3000;

      const swiperOptions = {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: loop,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: this.swiperNext,
          prevEl: this.swiperPrev,
        },
        pagination: {
          el: this.swiperPagination,
          clickable: true,
        },
        scrollbar: {
          el: this.swiperScrollbar,
        },
      };

      if (autoplay) {
        swiperOptions.autoplay = {
          delay: autoplayDelay,
          disableOnInteraction: false,
        };
      }

      this.slideshowSwiper = new Swiper(this.swiperContainer, swiperOptions);

      // Trigger entrance animation on init and on slide change
      const triggerEntrance = () => {
        const all = this.querySelectorAll('.new-slideshow-content-inner .content');
        all.forEach(el => el.classList.remove('is-enter'));
        // force reflow so animation restarts
        // eslint-disable-next-line no-unused-expressions
        this.offsetWidth;
        const active = this.swiperContainer.querySelector('.swiper-slide-active');
        if (active) {
          const content = active.querySelector('.new-slideshow-content-inner .content');
          if (content) content.classList.add('is-enter');
        }
      };

      // run on init
      setTimeout(triggerEntrance, 50);
      // run on slide changes
      this.slideshowSwiper.on && this.slideshowSwiper.on('slideChangeTransitionStart', () => {
        triggerEntrance();
      });
    }

    slideClickHandler() {
      this.slideItems.forEach(item => {
        item.addEventListener('click', (e) => {
          const link = item.dataset.link;
          if (link) {
            window.location.href = link;
          }
        })
      })
    }
  }

  customElements.define('slide-show', Slideshow);
}
